<script>
import BarChart from 'shared/components/charts/NewBarChart.vue';

export default {
      components: { BarChart },
      props: {
            items: { type: Array, default: () => [] },
            title: { type: String, default: '' },
            unit: { type: String, default: '' }, 
      },
      data() {
            return {
                  hiddenMap: {},
            };
      },
            methods: {
                  toggleLegend(i) {
                        this.$set(this.hiddenMap, i, !this.hiddenMap[i]);
                  },
            },
      computed: {
            _maxValue() {
                  const vals = (this.items || []).map(item => {
                        const total = (item.series || []).reduce((s, p) => s + (p?.value || 0), 0);
                        return total;
                  });
                  return Math.max(0, ...vals);
            },
            collection() {
                  const labels = [''];
                  const datasets = (this.items || []).map((item, i) => {
                        const total = (item.series || []).reduce((s, p) => s + (p?.value || 0), 0);
                        return {
                              label: item.label,
                              data: [total],
                              backgroundColor: item.color,
                              borderRadius: 90,
                              maxBarThickness: 12,
                              categoryPercentage: 0.5,      
                              borderSkipped: false,
                              hidden: !!this.hiddenMap[i],
                        };
                  });
                  return { labels, datasets };
            },
            chartOptions() {
                  return {
                        responsive: true,
                        maintainAspectRatio: false,
                        layout: { padding: 0 },
                        plugins: {
                              legend: { display: false },
                              tooltip: {
                                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                    titleColor: '#fff',
                                    bodyColor: '#fff',
                                    borderColor: 'rgba(255, 255, 255, 0.1)',
                                    borderWidth: 1,
                                    cornerRadius: 8,
                                    displayColors: true,
                                    callbacks: {
                                          label: ctx => `${ctx.dataset.label}: ${ctx.parsed.y ?? ctx.parsed} ${this.unit}`,
                                    },
                              },
                              title: { display: false },
                        },
                        scales: {
                              x: {
                                    grid: { display: false },
                                    ticks: { display: false },
                                    offset: true,
                              },
                              y: {
                                    beginAtZero: true,
                                    ticks: {
                                          color: 'rgba(113, 118, 128, 1)',
                                          padding: 12,
                                          font: {
                                                size: 12
                                          },
                                          callback: (value, index, ticks) => {
                                                if (index === ticks.length - 1 && value > 0) {
                                                      return `${this.$t('REPORT.CHART_UNITS.ABOVE')} ${value} ${this.unit}`;
                                                }
                                                return value + ' ' + this.unit;
                                          },
                                    },
                                    grid: { color: 'rgba(113, 118, 128, 0.2)' },
                                    border: { display: false }
                              },
                        },
                  };
            }
      },
};
</script>
<template>
      <div class="w-full">
            <!-- Chart Title -->
            <div v-if="title" class="mb-4">
                  <h3 class="text-xs font-bold text-gray-900 dark:text-n-gray-3">{{ title }}</h3>
            </div>
            
            <div class="h-[260px]">
                  <BarChart :collection="collection" :chart-options="chartOptions" />
            </div>
            <div class="ml-3 mt-6 max-w-[200px]">
                  <ul class="space-y-4">
                        <li v-for="(it, i) in items" :key="i" class="flex items-center gap-1 cursor-pointer select-none"
                              @click="toggleLegend(i)">
                              <span :style="{ background: it.color, opacity: hiddenMap[i] ? 0.35 : 1 }"
                                    class="inline-block h-3 w-3 rounded-full" />
                              <span class="text-[12px] dark:text-n-gray-3"
                                    :class="hiddenMap[i] ? 'opacity-60 line-through' : ''">{{ it.label }} </span>
                        </li>
                  </ul>
            </div>
      </div>
</template>